import type { ReactNode, Ref } from "react";
import { tv } from "tailwind-variants";
import { cn } from "../../../lib/cn";
import { useMessage } from "./Context";

type BubbleSurfaceProps = {
    children: ReactNode;
    spacing?: "content" | "image";
    shape?: "message" | "rounded";
    hasLabel?: boolean;
    className?: string;
    ref?: Ref<HTMLDivElement>;
};

export function BubbleSurface({
    children,
    spacing = "content",
    shape = "message",
    hasLabel = false,
    className,
    ref,
}: BubbleSurfaceProps) {
    const { sender, deliveryStatus } = useMessage();

    return (
        <div
            ref={ref}
            className={cn(
                surface({
                    sender,
                    tone: deliveryStatus === "failed" ? "failed" : "default",
                    spacing,
                    shape,
                    hasLabel,
                }),
                className,
            )}
        >
            {children}
        </div>
    );
}

const surface = tv({
    base: "relative min-w-min max-w-full break-words p-12",
    variants: {
        sender: {
            agent: "bg-component-chat-agent",
            member: "bg-component-chat-member",
        },
        tone: {
            default: "",
            failed: "text-text-secondary",
        },
        spacing: {
            content: "",
            image: "overflow-hidden p-0",
        },
        shape: {
            message: "",
            rounded: "rounded-rounded",
        },
        hasLabel: {
            true: "mt-12 pt-20",
            false: "",
        },
    },
    compoundVariants: [
        {
            sender: "agent",
            shape: "message",
            className: "rounded-rounded rounded-bl-sharp",
        },
        {
            sender: "member",
            shape: "message",
            className: "rounded-rounded rounded-br-sharp",
        },
    ],
});
